import React from 'react'
import { Doughnut } from 'react-chartjs-2'

/**
 * Composant pour le graphique perimetre_supervise (Doughnut)
 */
const PerimetreSuperviseChart = ({ data, options }) => {
  if (!data || !options || !data.labels || !data.datasets) {
    return null
  }

  return (
    <Doughnut
      id="chart_perimetre_supervise"
      options={options}
      data={data}
    />
  )
}

export default PerimetreSuperviseChart
